"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangeAndReturnNotCalledError = exports.ShapeUpdaterNonShapeChildError = exports.ChangeRequestNoPrevDataError = exports.ReducerInvalidStepError = exports.ReducerInvalidActionError = exports.ReadOnlyError = void 0;

var ReadOnlyError = function ReadOnlyError() {
  return new Error("This property is read-only");
};

exports.ReadOnlyError = ReadOnlyError;

var ReducerInvalidActionError = function ReducerInvalidActionError(actionType) {
  return new Error("\"".concat(actionType, "\" is not a valid action"));
};

exports.ReducerInvalidActionError = ReducerInvalidActionError;

var ReducerInvalidStepError = function ReducerInvalidStepError(stepType) {
  return new Error("\"".concat(stepType, "\" is not a valid action step type"));
};

exports.ReducerInvalidStepError = ReducerInvalidStepError;

var ChangeRequestNoPrevDataError = function ChangeRequestNoPrevDataError() {
  return new Error("ChangeRequest data cannot be accessed before setting changeRequest.prevData");
};

exports.ChangeRequestNoPrevDataError = ChangeRequestNoPrevDataError;

var ShapeUpdaterNonShapeChildError = function ShapeUpdaterNonShapeChildError() {
  return new Error("Every child value on a collection returned from a shape updater must be a ParcelShape");
};

exports.ShapeUpdaterNonShapeChildError = ShapeUpdaterNonShapeChildError;

var ChangeAndReturnNotCalledError = function ChangeAndReturnNotCalledError() {
  return new Error("_changeAndReturn unchanged");
};

exports.ChangeAndReturnNotCalledError = ChangeAndReturnNotCalledError;